export default __webpack_public_path__ + "locales/uk-UA/Ldap.json?hash=2c56a882ebced887f9b4ff654c5ac1fc";